import { Vue } from 'vue-property-decorator'
import { JtechAxios } from 'src/plugins/axios'
import axios from 'axios'
import { GlobalController } from 'src/shared/global/GlobalController'

export const repository = {
  resolveForm: async function (action, params, funcionalidade) {
    const dados = params || {}
    const {
      data: { forms }
    } = await JtechAxios.request().getFWForm(action, dados, funcionalidade)
    return forms
  },

  resolveModel: async function (action, params) {
    const dados = params || {}
    const { data } = await JtechAxios.request().getFWData(action, {
      idAcaoGrid: dados ? dados.id : null, ...dados
    })
    return data
  },

  resolve: async function (action, params) {
    const dados = params || {}
    let {
      data: { forms }
    } = await JtechAxios.request().getFWForm(action, {})
    const { data } = await JtechAxios.request().getFWData(action, {
      idAcaoGrid: dados ? dados.id : null, ...dados
    })
    if (data.relacionamentos) { forms = forms.map(form => Object.assign(form, { ...data })) } else {
      forms = forms.map(form =>
        Object.assign(form, { ...data[form.name] })
      )
    }
    return forms
  },

  resolveLogic: async function (action, params) {
    const dados = params || {}
    const { data } = await JtechAxios.request().getFWLogic(action, {
      idAcaoGrid: dados ? dados.id : null, ...dados
    })
    return data
  },

  resolveDatatable: async function (action, params, funcionalidade) {
    const dados = params || {}
    const {
      data: {
        datatables: [{ ...datatable }]
      }
    } = await JtechAxios.request().getFWForm(action, dados, funcionalidade)
    return datatable
  },

  resolveDatatableModel: async function (action, params) {
    const dados = params || {}
    const {
      data: { registros, totalCount }
    } = await Vue.prototype.$sansys.pesquisar(action, dados)
    return { registros, totalCount }
  },

  resolveSelect: async (action, params, funcionalidade) => {
    const dados = params || {}
    const { data } = await JtechAxios.request().getFWDadosComboAtual(
      action,
      dados
    )
    return data
  },

  resolveSelectAjax: function (action, params, funcionalidade) {
    const dados = params || {}
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await JtechAxios.request().getFWDadosCombo(
          action,
          dados
        )
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },

  resolveSearch: function (action, params, funcionalidade) {
    const dados = params || {}
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await JtechAxios.request().pesquisarDadosSelecao(
          action,
          dados
        )
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },

  delete: async function (action, params) {
    const { data } = await JtechAxios.request().deleteCrudFW(action, {
      idAcaoGrid: params.id
    })
    return data
  },

  inactivate: async function (action, params) {
    const { data } = await JtechAxios.request().inactivateCrudFW(action, {
      idAcaoGrid: params.id
    })
    return data
  },

  activate: async function (action, params) {
    const { data } = await JtechAxios.request().activateCrudFW(action, {
      idAcaoGrid: params.id
    })
    return data
  },

  create: async function (action, params) {
    const { data } = await JtechAxios.request().postCrudFW(action, { ...params, id: null })
    return data
  },

  update: async function (action, params) {
    const { data } = await JtechAxios.request().putCrudFW(action, {
      idAcaoGrid: params.id, ...params
    })
    return data
  },

  updateFile: async function (action, name, blob) {
    const http = axios.create({
      baseURL: process.env.VUE_APP_URL,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      timeout: 300 * 1000,
      responseEncoding: 'iso-8859-1',
      transformRequest: [
        (data, headers) => {
          const globalController = GlobalController.getInstance()
          if (globalController && globalController.authResp && globalController.authResp.token) { headers.Authorization = 'Bearer ' + globalController.authResp.token }
          return data
        }
      ]
    })
    const form = new FormData()
    form.append(name, blob)
    const url = `fw-data/defaultAprFW.ajax?method=uploadFile&interface=${action}`
    const {
      data: { upload }
    } = await http.post(url, form)
    return upload[name]
  },
  montarTela: (action, params, funcionalidade) => {
    const dados = params || {}
    return new Promise(async (resolve, reject) => {
      try {
        const tela = await Vue.prototype.$sansys.montarTela(action, dados)
        resolve(tela)
      } catch (e) {
        reject(e)
      }
    })
  },
  manterComponente: (action, params, funcionalidade) => {
    const dados = params || {}
    return new Promise(async (resolve, reject) => {
      try {
        const data = await Vue.prototype.$sansys.manterComponente(
          action,
          dados
        )
        resolve(data)
      } catch (e) {
        reject(e)
      }
    })
  },
  downloadFile: async function (name, formatoRelatorio, opt = '', blobType = 'image/png') {
    const http = axios.create({
      baseURL: process.env.VUE_APP_URL,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'arraybuffer', // <-- responseType
      timeout: 300 * 1000,
      responseEncoding: 'iso-8859-1',
      transformRequest: [
        (data, headers) => {
          const globalController = GlobalController.getInstance()
          if (globalController && globalController.authResp && globalController.authResp.token) { headers.Authorization = 'Bearer ' + globalController.authResp.token }
          return data
        }
      ]
    })
    const form = new FormData()
    form.append('nmArquivo', name)
    form.append('relFormatoRelatorio', formatoRelatorio)
    form.append('opt', opt)
    const url = `fw-data/defaultAprFW.ajax?method=downloadFile&opt=${opt}&nmArquivo=${name}&relFormatoRelatorio=${formatoRelatorio}`
    const { data } = await http.post(url, form)
    const blob = new Blob([data], { type: blobType })
    return blob
  }
}
